<template>
  <v-app class="fs-main-app">
    <router-view></router-view>

    <transition name="fade">
      <div class="animation" v-if="getShowAnimation">
        <Lottie :options="defaultOptions" v-on:animCreated="handleAnimation"/>
      </div>
    </transition>
  </v-app>
</template>

<script>
import * as animationData from '@/assets/loading-animation.json'
import Lottie from '@/components/Lottie'
import { mapGetters } from 'vuex'

export default {
  components: {
    Lottie
  },
  data () {
    return {
      defaultOptions: { animationData: animationData.default }
    }
  },
  computed: {
    ...mapGetters('global', ['getLoading', 'getShowAnimation'])
  },
  methods: {
    handleAnimation (anim) {
      // console.log('handleAnimation')
      // this.anim.autoplay = true
      this.anim = anim
      this.anim.setSpeed(0.8)
      this.anim.loop = false
    }
  }
}
</script>

<style lang="scss">
@import '@/sass/variables.scss';

.fs-main-app {
  // background-color: #FAFAFA !important;
}

/* LOTTIE */
.animation {
  z-index: 100;
  position: absolute;
  top: 0px;
  height: 100vh;
  width: 100vw;
  background-color: #0A0923;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .7s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
